/**
 * UTC/local time display conversion (`activity-timestamps` spec:
 * "Switching display mode does not alter stored time"). Pure
 * presentation functions only — nothing here ever mutates a stored
 * timestamp; they take a `Date` (an absolute instant) and return a
 * display string in the requested mode.
 */

export type TimeDisplayMode = 'utc' | 'local'

export function formatTimestamp(instant: Date, mode: TimeDisplayMode): string {
  if (mode === 'utc') {
    return instant.toISOString()
  }
  return instant.toLocaleString(undefined, { timeZoneName: 'short' })
}
